import { useCallback, useState } from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import { useStore } from '../../../../../models'
import { InfoRectangle } from '../../../InfoRectangle'
import { translate } from '../../../../../i18n'
import { PlayerInfo } from '../../../PlayerHand/PlayerInfo'
import { fontFamily } from '../../../../../theme'
import { observer } from 'mobx-react-lite'
import MicIconOff from '../../../assets/Mic--off.svg'
import { DS } from '../../../../../design-system'
import { PlayerCellVideo } from '../../../PlayerCell/PlayerCellVideo'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export interface GameStartProps {
  onClose: () => void
}

const isWeb = Platform.OS === 'web'

export const GameStart = observer(({ onClose }: GameStartProps) => {
  const {
    game: { players, startGame, isGameStartSheetOpen, previewVideoWasShown },
    messages: { clearSnack },
    communication: { isLocalUserJoined, isLocalUserVideoHidden, isLocalUserMuted }
  } = useStore()

  const [startingGame, setStartingGame] = useState(false)
  const showVideo = isLocalUserJoined && !isLocalUserVideoHidden && isGameStartSheetOpen && previewVideoWasShown
  const showAudioIcon = isLocalUserJoined && isLocalUserVideoHidden && !isLocalUserMuted
  const showMuted = isLocalUserJoined && isLocalUserVideoHidden && isLocalUserMuted

  const handleStart = useCallback(async () => {
    try {
      // TODO: This should be moved to a step function in the api.
      setStartingGame(true)
      await startGame()
        .then()
        .catch(() => {
          setStartingGame(false)
        })
    } catch (error) {
      console.error('doStart', error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [players, onClose, startGame])

  return (
    <BottomSheetView
      style={
        Platform.OS !== 'web'
          ? {
              flex: 1
            }
          : {}
      }
    >
      <View style={[styles.container, Platform.select({ ios: { gap: 16 }, android: { gap: 8 }, web: { gap: 24 } })]}>
        <View>
          <PlayerInfo />
        </View>
        <View style={{ alignItems: 'center' }}>
          <DS.Button
            disabled={startingGame}
            variant="Large/Primary"
            type={'On Light'}
            onPress={handleStart}
            style={{ width: isWeb ? '50%' : '100%' }}
          >
            {startingGame ? translate('common.startingGame') : translate('common.startNow')}
          </DS.Button>
        </View>
        <DS.Frame gap={'16'} row style={{ alignItems: 'center' }}>
          {showMuted ? (
            <View style={styles.audioIconContainer}>
              <MicIconOff />
            </View>
          ) : null}
          {showVideo ? <PlayerCellVideo videoStyle={{ borderRadius: 24, width: 48, height: 48 }} /> : null}
          {showAudioIcon ? (
            <View style={styles.audioIconContainer}>
              <DS.Icon name="Audio" size={24} color={'Global/Black'} />
            </View>
          ) : null}
          <InfoRectangle customStyle={{ flex: 1 }}>
            <DS.Text variant="Caption/Bold">{translate('newGameScreen.common.waitingForGame')}</DS.Text>
          </InfoRectangle>
        </DS.Frame>
      </View>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16
  },
  text: {
    fontFamily: fontFamily.GTAmericaExtendedMedium
  },
  audioIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: DS.palette['Global/White'],
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  }
})
